import { matchPath } from 'react-router-dom'

import { MACROAREAS } from './consts'
import type { Macroarea } from './types'

export function getMacroareaFromLocation(location?: Location): Macroarea {
  const pathname = location?.pathname ?? window?.location?.pathname

  for (const { pathname: path, macroarea } of MACROAREAS) {
    if (matchPath(pathname, { path, exact: true })) {
      return macroarea
    }
  }
  return 'Undefined Macroarea'
}
